module.exports = __webpack_public_path__ + "f5ec551303cc4e0ed1aa838c3f92a7af.svg";


//////////////////
// WEBPACK FOOTER
// ./components/zynappse-crud/assets/images/ic_calendar.svg
// module id = 1082
// module chunks = 0